<div class="tw-flex tw-flex-col tw-bg-white tw-h-full font-noto">
  @if (loading) {
    <loading class="tw-flex-1 tw-justify-self-center tw-self-center"></loading>
  }
  @if (showHeaderBar && !loading) {
    <div class="tw-grid tw-grid-cols-[40px_1fr_40px] tw-w-full tw-h-18 tw-px-6 tw-bg-black tw-z-[100] tw-items-center tw-flex-shrink-0">
      <div class="tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-rounded-xl" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50" [iconName]="'arrow_back'"></cs-icon>
      </div>
      @if (isEdit) {
        <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal tw-justify-self-center" i18n="@@yourDeliveryAddress">Edit your address</span>
      } @else if (showFillRemainingState) {
        <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal tw-justify-self-center" i18n="@@completeYourDeliveryAddress">Complete your delivery address</span>
      } @else {
        <span class="tw-text-300 tw-text-white tw-font-lexend tw-font-normal tw-justify-self-center" i18n="@@addAddress">Add your delivery address</span>
      }
    </div>
  } @else {
    <div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
    </div>
  }
  @if (showFillRemainingState) {
    <div id="locationDetectedStrip" class="tw-flex tw-min-h-14 tw-flex-shrink-0 tw-items-center tw-gap-2 tw-bg-teal-100 tw-px-6 tw-py-3">
      <cs-icon class="tw-h-6 tw-w-6 tw-shrink-0" [iconName]="'my_location'"></cs-icon>
      <div class="tw-flex tw-flex-1 tw-flex-col">
        <span class="tw-font-lexend tw-text-100 tw-font-semibold tw-uppercase tw-tracking-wide tw-text-gray-800" i18n="@@locationDetected">Location detected</span>
        <span class="tw-font-lexend tw-text-100 tw-text-gray-500">{{ detectedLocationLine }}</span>
      </div>
      <div id="removeDetectedLocation" role="button" class="tw-font-body tw-text-200 tw-font-bold tw-text-teal-600" (click)="removeDetectedLocation()" i18n="@@removeDetectedLocation">Remove</div>
    </div>
  }
  <!--  Main scrollable container-->

  @if (!loading) {
    <div  class="tw-flex-1 tw-overflow-y-auto tw-px-[21px]" [class]="showHeaderBar ? 'tw-pt-5' : 'tw-pt-24'">
      <!--    Main title of the page -->
      @if (!showHeaderBar) {
        <div class="tw-mb-[9px]">
          @if (showFillRemainingState) {
            <div class="tw-font-bold tw-text-black tw-font-lexend tw-font-[700] tw-pl-1 tw-text-400" i18n="@@completeYourDeliveryAddress">Complete your delivery address</div>
          } @else if (!isEdit) {
            <div class="tw-font-bold tw-text-black tw-font-lexend tw-font-[700] tw-pl-1 tw-text-400" i18n="@@addAddress">Add your delivery address</div>
          }
          @if (isEdit) {
            <div class="tw-font-bold tw-text-black tw-font-lexend tw-font-[700] tw-pl-1 tw-text-400" i18n="@@yourDeliveryAddress">Edit your address</div>
          }
        </div>
      }
      <!--    subtitle -->
      @if (showAddressDisclaimer) {
        <div class="tw-text-200 tw-text-gray-400" [class]="disclaimerSpacingClass" i18n="@@addressDisclaimer">Complete address help you get your order faster</div>
      }
      <address-form
        #form=""
        [(data)]="addressForm"
        [prefillAddressShiprocketExperiment]="prefillAddressShiprocketExperiment"
        [shiprocketAddressExists]="shiprocketAddressExists"
        [shiprocketAddressesCount]="shiprocketAddressesCount"
        [shiprocketSticky]="shiprocketSticky"
        [locationLoading]="isLocatingAddress"
        [hideLocationCta]="isAutofillFlow"
        [autofilledStyle]="showAutofilledFormStyle"
        [fromReviewOrderPage]="fromReviewOrderPage"
        (updateLocationInfo)="getLocationDetails()"
        >
        <!-- Shiprocket Banner when sticky is false (projected into address-form) -->
        @if (shouldShowShiprocketBannerNonSticky) {
          <shiprocket-address-banner
            #shiprocketBannerNonSticky
            shiprocketCta
            [shiprocketAddressesCount]="shiprocketAddressesCount"
            (findMyAddress)="openShiprocketAddressBottomsheet()"
            (selectAddress)="selectShiprocketAddress()"
          ></shiprocket-address-banner>
        }
      </address-form>
    </div>
  }

  <!--  Shiprocket address Banner - Sticky position (when sticky is true) -->
  @if (shouldShowShiprocketBannerSticky && !loading) {
    <div
      class="tw-px-[21px] tw-py-4 tw-transition-all tw-duration-200 tw-ease-in-out"
    [ngClass]="{
      'tw-invisible tw-h-0 tw-overflow-hidden': isKeyboardVisible,
      'tw-visible tw-h-auto': !isKeyboardVisible
    }">
      <shiprocket-address-banner
        #shiprocketBannerSticky
        [shiprocketAddressesCount]="shiprocketAddressesCount"
        (findMyAddress)="openShiprocketAddressBottomsheet()"
        (selectAddress)="selectShiprocketAddress()"
      ></shiprocket-address-banner>
    </div>
  }

  <!--  CTA container-->
  @if (!loading) {
    <div class="tw-flex-none tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white" [class]="isfromReviewOrderAndDeliveryDateExists ? 'tw-p-6 tw-pb-0' : 'tw-p-6'">
      @if (showAutofillLocationCta) {
        <button csButton="outlined"
          id="useMyCurrentLocationAutofill"
          type="button"
          class="tw-w-full tw-mb-2"
          [disabled]="!addressForm"
          (click)="startLocationAutofill()"
          i18n="@@useMyCurrentLocationCta"
        >Use my current location</button>
      } @else if (showLegacyLocationCta) {
        <button csButton="muted"
          id="useCurrentLocation"
          type="button"
          class="tw-w-full"
          [loading]="isLocatingAddress"
          [disabled]="!addressForm"
          (click)="getLocationDetails()"
          i18n="@@useMyCurrentLocation"
        >Use current location</button>
      }
      @if (showProceedToPayCta) {
        <button csButton
          id="proceedToPay"
          type="button"
          class="tw-w-full"
          [loading]="inProcess || (saveInProcess$ | async) || (checkoutInProgress$ | async)"
          (click)="saveAddress()"
          i18n="@@proceedToPay"
        >Proceed to pay</button>
      } @else if (isEdit) {
        <button csButton
          id="saveAddress"
          type="button"
          class="tw-w-full"
          [loading]="inProcess || (saveInProcess$ | async) || (checkoutInProgress$ | async)"
          (click)="saveAddress()"
          i18n="@@save"
        >Save</button>
      } @else if (fromMenu) {
        <button csButton
          id="saveAddressFromMenu"
          type="button"
          class="tw-w-full"
          [loading]="inProcess || (saveInProcess$ | async) || (checkoutInProgress$ | async)"
          (click)="saveAddress()"
          i18n="@@saveAddress"
        >Save address</button>
      } @else {
        <button csButton
          id="continueAddress"
          type="button"
          class="tw-w-full tw-bg-gray-400"
          [loading]="inProcess || (saveInProcess$ | async) || (checkoutInProgress$ | async)"
          (click)="saveAddress()"
          i18n="@@continue"
        >Continue</button>
      }
      @if (isfromReviewOrderAndDeliveryDateExists) {
        <div class="tw-mb-5">
          @if (!loading) {
            <app-expected-delivery-date
              [expectedDeliveryDate]="expectedDeliveryDate"
              [dayDifference]="dayDifference"
              />
          }
        </div>
      }
    </div>
  }
</div>
<!--popup ups-->
@if (popUpModal?.open) {
  <pop-up [class]="'tw-rounded-2.5 tw-p-4'" [show]="popUpModal?.open" [triggerDismiss]="true" (close)="closePopup()">
    <div>
      <div class="tw-mb-4 tw-font-bold tw-text-500" i18n="@@invalidPinTitle">Invalid Pincode</div>
      <div class="tw-mb-4 tw-text-400" i18n="@@invalidPincode">
      Pincode looks wrong, Do you want to autofill the correct pincode?
    </div>
      <div class="tw-flex tw-items-center tw-justify-end tw-flex-wrap">
        <div class="tw-w-1/2">
          <cs-button (click)="onClickYes()" [class]="'primary tw-w-full btn-xs tw-bg-teal-600'">
            <cs-button-text i18n="@@ok">Ok</cs-button-text>
          </cs-button>
        </div>
        <div class="tw-w-1/2">
          <cs-button (click)="closePopup()" [class]="'secondary only-text btn-xs tw-pl-0'">
            <cs-button-text i18n="@@no">No</cs-button-text>
          </cs-button>
        </div>
      </div>
    </div>
  </pop-up>
}
